import type {
    PersonalScheduleList,
    PersonalScheduleProgram,
    Program
} from '@/domain'

// A personal schedule the user is still running (not archived, stopped or
// finished).
export function isActivePersonalSchedule(e: { status: string }): boolean {
    return (
        e.status !== 'archived' &&
        e.status !== 'stopped' &&
        e.status !== 'finished'
    )
}

export function getActiveScheduleEntries(
    personalSchedule: PersonalScheduleProgram,
    programme: Program
): PersonalScheduleList[] {
    const authoredWorkouts = (programme.schedule || []).filter(
        (entry) => entry.kind === 'workout' && entry.lessonId
    )
    const authoredPairs = new Set(
        authoredWorkouts.map(
            (entry) =>
                `${entry.id.length}:${entry.id}${entry.lessonId!.length}:${entry.lessonId}`
        )
    )
    const sourced = personalSchedule.schedule.filter(
        (entry) =>
            entry.sourceScheduleId &&
            authoredPairs.has(
                `${entry.sourceScheduleId.length}:${entry.sourceScheduleId}${entry.lessonId.length}:${entry.lessonId}`
            )
    )

    if (sourced.length > 0) return sourced

    if (personalSchedule.schedule.some((entry) => entry.sourceScheduleId)) {
        return []
    }

    // Historical schedules predate sourceScheduleId. Until their first sync,
    // preserve their original order rather than hiding valid active days.
    return personalSchedule.schedule
}
